import React from 'react'
import { Container } from 'reactstrap'
import '../../styles/common-section.css'

const CommonSection = ({ title, eyebrow = 'Gadget Groove', subtitle }) => (
  <section className='common__section'>
    <Container>
      <span className='common__eyebrow'>{eyebrow}</span>
      <h1>{title}</h1>
      {subtitle && <p>{subtitle}</p>}
    </Container>
  </section>
)

export default CommonSection
